import { type Organisation, Roles, Statuses } from '@/models';

export const isPendingMemberOfOrg = (
  orgs: Organisation[],
  orgId?: string,
  userId?: string,
  phoneNumber?: string,
) => {
  return (
    !orgId ||
    orgs
      .find(org => org.id === orgId)
      ?.members?.find(
        member =>
          (member?.userId === userId || member?.phoneNumber === phoneNumber) &&
          (member?.role === Roles.MEMBER ||
            member?.role === Roles.OWNER ||
            member?.role === Roles.ADMIN) &&
          member?.status === Statuses.PENDING,
      )
  );
};
